import React, { Component, PropTypes } from 'react';
import './tenantImage.scss';

import ApiService from 'service/ApiService';

import GoOrg from 'react-icons/lib/go/home';

export default class TenantImage extends Component {
    render() {
        return (
            <div className={`tenant-image ${this.props.className ? this.props.className : ''}`}>
                <If condition={this.props.user.tenant_image}>
                    <img className="tenant-image-custom" src={ApiService.getApiUrl(`/tenants/${this.props.user.tenant_id}/image`)} />
                <Else />
                    <GoOrg className="tenant-image-default" />
                </If>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/views/tenantImage/TenantImage.js